var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28",
    "data-name": "Layer 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 18h42v40h-42z",
    fill: "#e2e7f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 53.781a2 2 0 0 0 2-2v-33.781h-38v35.781z",
    fill: "#eff2f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 18v-16h32l10 10v6z",
    fill: "#d23f34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.831 13.007v-5.176l-5.831-5.831h-32v13.007h35.831a2 2 0 0 0 2-2z",
    fill: "#e24f4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.72 58-20.261 4-10.459-52.977 18-3.417v52.394z",
    fill: "#a72b25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 2v10h10",
    fill: "#a72b25"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eff2f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 5h-3a1 1 0 0 0 -1 1v9h2v-4h2a3 3 0 0 0 0-6zm0 4h-2v-2h2a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 5h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-4a3 3 0 0 0 -3-3zm1 7a1 1 0 0 1 -1 1h-2v-6h2a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 7v-2h-5a1 1 0 0 0 -1 1v9h2v-4h4v-2h-4v-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m53 38v-15h-24v10h9l5 5z",
    fill: "#f29b99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 40v11a2 2 0 0 1 -2 2h-26a2 2 0 0 1 -2-2v-16a2 2 0 0 1 2-2h10l5 5h11a2 2 0 0 1 2 2z",
    fill: "#a72b25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 26h18v2h-18z",
    fill: "#f8ced7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 29h18v2h-18z",
    fill: "#f8ced7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 47v-9h-10l-5-5h-10a2 2 0 0 0 -2 2v14h25a2 2 0 0 0 2-2z",
    fill: "#d23f34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c872ab01ab7c29310d3bc2b7fc7107a0.svg";
export { ForwardRef as ReactComponent };